webpackJsonp([232290384560919],{

/***/ 1924:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"PdfExtractionTestResult","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"jobId","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"uploadBucket","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"uploadFilename","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"uploadPath","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":"Result of starting a 'Test Prompt' run: the submitted AI job id (which the client polls via the AI jobs endpoints) and the GCS reference to the uploaded PDF.","enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-pdf-extraction-test-result-7518de01f780098f40b4.js